import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function ValidationIssuesDisplay({ validationIssues }) {
    return (_jsx(_Fragment, { children: validationIssues.map((error, index) => (_jsx("p", { className: "mt-1 leading-7 text-red-400", children: error.message }, index))) }));
}
//# sourceMappingURL=ValidationIssuesDisplay.js.map